'use client'

import useSearchStore from '@app/components/search-section/store/search-store'

type Props = {
  children: React.ReactNode
}

const NoSearchVisiblityProvider = ({children}: Props) => {
  const {searchQuery} = useSearchStore()
  if (!!searchQuery) {
    return null
  }

  return <>{children}</>
}

export default NoSearchVisiblityProvider
